// Strip group prefixes like /(app) so /inventory and /(app)/inventory compare equal
export const normalizeNavPath = (p: string) => p.replace(/^\/\([^)]+\)/, '') || '/';

export const getRecipeDetailPath = (recipeId: string): string =>
  `/(app)/recipe-detail/${recipeId}`;
